import { type CSSProperties, type JSX } from 'react';

export interface SkeletonProps {
  /** Width. Number → px, string → as-is (e.g. '100%', '40%'). */
  width?: number | string;
  height?: number;
  borderRadius?: number;
}

/** Presentational shimmer placeholder (no state). Sized via inline styles. */
export function Skeleton(props: SkeletonProps): JSX.Element {
  const { width = '100%', height = 14, borderRadius = 4 } = props;
  const style: CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: `${height}px`,
    borderRadius: `${borderRadius}px`
  };
  return <div className="skeleton" style={style} aria-hidden="true" />;
}
